import type { ModelCandidate } from "@/services/adminModelCurrency";
import PriceChip from "./PriceChip";
import PriceLine from "./PriceLine";
import { NO_PRICE_WARNING } from "./helpers";

/** A candidate's price and how it compares, or a warning when we have no price for it. */
const CandidatePrice = ({ candidate }: { candidate: ModelCandidate }) => {
  if (!candidate.price) {
    return <p className="text-xs text-amber-700">{NO_PRICE_WARNING}</p>;
  }
  return (
    <div className="flex flex-wrap items-center gap-2">
      <PriceLine price={candidate.price} />
      <PriceChip ratio={candidate.priceVsCurrent} />
    </div>
  );
};

export default CandidatePrice;
